<template>
    <div class="form-container">



        <el-form :model="gw" ref="gw" label-width="100px" class="demo-dynamic">
            <el-form-item prop="name" label="官网名称" :rules="[
            { required: true, message: '请输入官网名称', trigger: 'blur' }
        ]">
                <el-input v-model="gw.name"></el-input>
            </el-form-item>

            <el-form-item prop="logo" label="logo设置" class="SeedlingsImg">
                <!-- <el-upload class="avatar-uploader" accept="image/*" :show-file-list="false" :action="fileUrl" :headers="{ 'Authorization': token }"
                    :on-change="uploadFile2" :on-remove="removeFile2" :on-success="handleSuccess">
                    <img v-if="gw.logo" :src="urlprefix+gw.logo" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload> -->
                <!-- <el-upload class="avatar-uploader" :action="fileUrl" :show-file-list="false" :on-success="handleSuccess"  :headers="{ 'Authorization': token }">
                    <img v-if="gw.logo" :src="urlprefix+gw.logo" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload> -->
                <el-upload v-if="!gw.logo" ref="uploadImg" class="seedlings-avatar-uploader radius_4 " :action="fileUrl"
                    name="file" :multiple="false" :limit="1" :show-file-list="false" :on-success="handleSuccess"
                    :headers="{ Authorization: token }">
                    <i style="border: 1px dashed #d9d9d9" class="el-icon-plus seedlings-avatar-uploader-icon icon"></i>
                    <div slot="tip" class="el-upload__tip" style="color: red;">
                        为了在大屏展示更好效果，建议尺寸为42*42，或同比例放大缩小</div>

                </el-upload>
                <div v-if="gw.logo" style="width: 120px; height: 120px; position: relative">
                    <span class="aaa">
                        <i v-if="gw.logo" class="el-icon-delete" style="" @click="delPreviewImg"></i>

                    </span>

                    <img v-if="gw.logo" :src="gw.logo" class="avatar">
                </div>
            </el-form-item>

            <div class="navList">
                <template v-for="(nav, index) in gw.navList">
                    <div style="width: 100%;display: flex;">
                        <el-form-item :prop="'navList.' + index + '.name'" style="width: 30%;"
                            :label="'导航名称' + (index + 1)" :rules="[
            { required: true, message: '请输入导航名称', trigger: 'blur' }
        ]">
                            <el-input v-model="nav.name"></el-input>
                        </el-form-item>

                        <el-form-item :prop="'navList.' + index + '.imageList'" :rules="[
            {
                required: true,
                message: '请至少上传一张导航内容图片！',
                trigger: 'change'
            }
        ]" style="width: 60%;" :label="'导航内容' + (index + 1)">
                            <el-upload accept="image/*" :action="fileUrl" :file-list="nav.imageList"
                                :headers="{ 'Authorization': token }" list-type="picture-card" :on-change="uploadFile2"
                                :on-remove="(file, fileList) => removeFile2(file, fileList, index)"
                                :on-success="(response, file, fileList) => handleSuccess2(response, file, fileList, index)">
                                <div slot="tip" class="el-upload__tip" style="color: red;">
                                    注：为了在大屏展示更好效果，建议尺寸为1280*720，或同比例放大缩小，图片仅支持jpg/png格式</div>
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>

                        <span style="width: 10%; height: 1em;font-size: 20px">
                            <i class="el-icon-plus" v-if="index == 0" @click="addNav()"></i>
                            <i class="el-icon-minus" v-if="gw.navList.length > 1" @click="removeNav(index)"></i>
                        </span>
                    </div>

                </template>
                <div>页尾设置</div>

                <el-form-item prop="footerShow" label="页尾是否显示">
                    <el-radio-group v-model="gw.footerShow">
                        <el-radio label="显示"></el-radio>
                        <el-radio label="隐藏"></el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item prop="lxfs" label="联系方式" :rules="[
            { required: true, message: '请输入联系方式', trigger: 'blur' }
        ]">
                    <el-input v-model="gw.lxfs"></el-input>
                </el-form-item>
                <el-form-item prop="dz" label="地址" :rules="[
            { required: true, message: '请输入地址', trigger: 'blur' }
        ]">
                    <el-input v-model="gw.dz"></el-input>
                </el-form-item>
                <el-form-item prop="bqsy" label="版权所有" :rules="[
            { required: true, message: '请输入版权所有', trigger: 'blur' }
        ]">
                    <el-input v-model="gw.bqsy"></el-input>
                </el-form-item>
                <el-form-item prop="bahpre" label="备案号前缀" :rules="[
            { required: true, message: '请输入备案号前缀', trigger: 'blur' }
        ]">
                    <el-input v-model="gw.bahpre"></el-input>
                </el-form-item>
                <el-form-item prop="bah" label="备案号" :rules="[
            { required: true, message: '请输入备案号', trigger: 'blur' }
        ]">
                    <el-input v-model="gw.bah"></el-input>
                </el-form-item>
            </div>

            <el-form-item>
                <el-button type="primary" @click="submitForm('gw')">发布</el-button>
                <el-button @click="previewForm('gw')">预览</el-button>
                <el-button @click="goBack">返回</el-button>
            </el-form-item>

        </el-form>

    </div>
</template>

<script>
import CFG from "@/config/config";
import * as api from "@/api/large-screen";
import * as cloudScreenApi from "@/api/cloud-screen";
export default {
    data() {
        return {
            urlprefix: CFG.LOTIP,
            token: "Bearer" + " " + this.$store.state.token,
            fileUrl: CFG.LOTIP + "/file/uploadFile?url=qygw", //图片文件上传地址,
            gw: {
                name: "长林丰草",
                logo: "",
                navList: [{
                    name: "",
                    imageList: []
                }],
                footerShow: "显示",
                lxfs: "联系方式：marketing@xaclfc.com",
                dz: "陕西省西安市高新区锦业一路56号研祥城市广场A座2206",
                bqsy: '© 西安长林丰草生态科技有限公司',
                bahpre: '© 2021 All Right Reserved',
                bah: "陕ICP备2021011728号-1",
                systemSid: this.$route.params.systemSid
            },
        };
    },
    methods: {
        goBack() {
      window.history.back();
    },
        addNav() {
            let nav = {
                name: "",
                imageList: []
            }
            this.gw.navList.push(nav)
        },
        removeNav(index) {
            this.gw['navList'].splice(index, 1)
        },
        handleSuccess(res, file, fileList) {
            console.log(res, file, fileList);

            this.gw.logo = res.data.url

        },
        handleSuccess2(res, file, fileList, index) {
            console.log(res, file, fileList, index);
            let arr = JSON.parse(JSON.stringify(this.gw.navList[index].imageList))
            res.data.url = res.data.url
            arr.push(res.data)
            this.gw.navList[index].imageList = arr
            // this.gw.logo = res.data.url

        },
        delPreviewImg() {
            this.gw.logo = ""
        },
        removeFile2(a, b, index) {
            // this.surveyData.whFile=null
            // console.log(this.surveyData.zpList)
            console.log(a, b, index)

            this.gw.navList[index].imageList = this.gw.navList[index].imageList.filter(item => item.uid != a.uid)

        },
        uploadFile2(a, b, c) {
            // console.log(a.raw.path)

        },
        submitForm(formName) {
            console.log(this.gw)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.saveConfig()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        previewForm(formName) {
            // 处理表单预览逻辑
            console.log('预览表单', this.gw);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.viewPage()
                } else {
                    this.$message.error("请完善字段配置！")
                    return false;
                }
            });
        },
        getQygw() {
            cloudScreenApi.getQygw(this.$route.params.systemSid).then(res => {
                if (res.resp_code == "10000") {
                    console.log(res.data, "==================")
                    if (res.data) {
                        let gw = res.data
                        if (gw['nav']) {
                            let nav = gw['nav']
                            // nav = nav.replaceAll("/large-screen", this.urlprefix + "/large-screen")
                            gw['navList'] = JSON.parse(nav)
                        }
                        this.gw = gw

                    } else {
                        this.gw = {
                            name: "长林丰草",
                            logo: "",
                            navList: [{
                                name: "",
                                imageList: []
                            }],
                            footerShow: "显示",
                            lxfs: "联系方式：marketing@xaclfc.com",
                            dz: "陕西省西安市高新区锦业一路56号研祥城市广场A座2206",
                            bqsy: '© 西安长林丰草生态科技有限公司',
                            bahpre: '© 2021 All Right Reserved',
                            bah: "陕ICP备2021011728号-1",
                            systemSid: this.$route.params.systemSid
                        }
                    }
                } else {
                    this.$message.error("获取参数配置失败！")
                }
            });
        },
        saveConfig() {
            let gw = JSON.parse(JSON.stringify(this.gw))
            let nav = JSON.stringify(gw.navList)
            // nav = nav.replaceAll(this.urlprefix, "")
            gw['nav'] = nav
            api.updateQygw(gw).then((res) => {
                if (res.resp_code == "10000") {
                    this.getQygw()
                    this.$message.success(gw.id ? "修改成功！" : "发布成功");
                }
            });
        },
        viewPage() {
            // this.$router.push({path:"/cloud_screen/"+this.device.id,query:this.formInline})
            let o = {
                name: this.gw.name,
                logo: this.gw.logo,
                navList: JSON.stringify(this.gw.navList),
                footerShow: this.gw.footerShow,
                lxfs: this.gw.lxfs,
                dz: this.gw.dz,
                bqsy: this.gw.bqsy,
                bahpre: this.gw.bahpre,
                bah: this.gw.bah,
                type: "预览"
            }

            const { href } = this.$router.resolve({
                path: "/website_view/" + this.$route.params.systemSid, query: o
            });
            window.open(href, "_blank");
        },
    },
    mounted() {
        cloudScreenApi.getQygw(this.$route.params.systemSid).then(res => {
            if (res.resp_code == "10000") {
                console.log(res.data, "==================")
                if (res.data) {
                    let gw = res.data
                    if (gw['nav']) {
                        let nav = gw['nav']
                        // nav = nav.replaceAll("/large-screen", this.urlprefix + "/large-screen")
                        gw['navList'] = JSON.parse(nav)
                    }
                    this.gw = gw

                } else {
                    this.gw = {
                        name: "长林丰草",
                        logo: "",
                        navList: [{
                            name: "",
                            imageList: []
                        }],
                        footerShow: "显示",
                        lxfs: "联系方式：marketing@xaclfc.com",
                        dz: "陕西省西安市高新区锦业一路56号研祥城市广场A座2206",
                        bqsy: '© 西安长林丰草生态科技有限公司',
                        bahpre: '© 2021 All Right Reserved',
                        bah: "陕ICP备2021011728号-1",
                        systemSid: this.$route.params.systemSid
                    }
                }
            } else {
                this.$message.error("获取参数配置失败！")
            }
        });
    }

};
</script>

<style scoped lang="scss">
//  .navList /deep/ .el-upload-list {
//   transition: none !important; 
// } 

//  .navList /deep/ .el-upload-list__item.is-ready,
// .el-upload-list__item.is-uploading {
//     display: none !important;
// }

// .navList /deep/ .el-loading-mask{
//     border: 1px dashed #c0ccda;
// } 

.aaa:hover {
    opacity: 1;
}

.aaa {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, .5);
    -webkit-transition: opacity .3s;
    transition: opacity .3s;
    line-height: 100px;
}

.SeedlingsImg {
    .iconImage:hover {
        opacity: 1;
    }

    .seedlings-avatar-uploader {
        border: none !important;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .seedlings-avatar-uploader {
        border: 1px dashed #d9d9d9;
    }

    .seedlings-avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .seedlings-avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        line-height: 120px;
        text-align: center;
    }

    .icon-shibai {
        height: 18px;
        line-height: 18px;
    }
}

.avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
}

.avatar {
    width: 120px;
    height: 120px;
    display: block;
}

.form-container {
    /* max-width: 800px; */
    /* margin: 0 auto; */
    padding: 20px;
}

.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

input {
    width: 100%;
    padding: 8px;
    margin-bottom: 10px;
}

.note {
    font-size: 12px;
    color: #666;
    margin-top: 5px;
}

.nav-buttons {
    margin-bottom: 10px;
}

.nav-items {
    display: flex;
    flex-wrap: wrap;
}

.nav-items input {
    width: auto;
    margin-right: 10px;
    margin-bottom: 5px;
}

.image-upload {
    display: flex;
    flex-wrap: wrap;
}

.image-item {
    margin-right: 10px;
    margin-bottom: 10px;
}

.image-preview {
    max-width: 200px;
    max-height: 100px;
    margin-top: 5px;
}

.logo-preview {
    max-width: 100px;
    max-height: 100px;
    margin-top: 5px;
}

.form-actions {
    display: flex;
    justify-content: flex-start;
}

.form-actions button {
    margin-right: 10px;
    padding: 8px 16px;
}
</style>

<style>
.navList /deep/ .el-upload-list {
    transition: none !important;
}

.navList /deep/ .el-upload-list__item.is-ready,
.el-upload-list__item.is-uploading {
    display: none !important;
}

.navList /deep/ .el-loading-mask {
    border: 1px dashed #c0ccda;
}
</style>